
export default () => [
    { id: 'natural', name: 'resources.common.fields.natural_person' },
    { id: 'moral', name: 'resources.common.fields.moral_person' }
]